/**
 * Patio Door Parts return request form.
 * Same field flow as the All About Doors return template; styled/submitted on this storefront.
 */
(function () {
  'use strict';

  var form = document.getElementById('main_form');
  if (!form) return;

  var CUSTOMER_FAULT = ['ordered_wrong_part', 'bought_by_mistake', 'ordered_too_many', 'does_not_fit'];
  var COMPANY_FAULT = ['sent_wrong_item', 'missing_parts', 'item_damaged', 'not_like_picture', 'other'];
  var REASON_LABELS = {
    ordered_wrong_part: 'Ordered wrong part',
    bought_by_mistake: 'Bought by mistake',
    ordered_too_many: 'Ordered too many',
    sent_wrong_item: 'I was sent the wrong item',
    missing_parts: 'Missing parts',
    item_damaged: 'Item damaged',
    does_not_fit: 'The item does not fit',
    not_like_picture: "Doesn't match picture",
    other: 'Other'
  };
  var EMAIL_RE = /^(?:[a-zA-Z0-9!#$%&*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  var MAX_PHOTO_BYTES = 10 * 1024 * 1024;
  var MIN_SUBMIT_MS = 3500;
  var loadTime = Date.now();

  function $(id) { return document.getElementById(id); }
  function val(id) {
    var el = $(id);
    return el ? String(el.value || '').trim() : '';
  }
  function checked(name) {
    var el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }
  function show(el, on) {
    if (el) el.hidden = !on;
  }
  function isVisible(el) {
    return !!(el && !el.hidden);
  }
  function phoneDigits(phone) {
    var digits = String(phone || '').replace(/[\s.\-()+]/g, '');
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.substring(1);
    return digits;
  }
  function validPhone(phone) {
    var digits = phoneDigits(phone);
    return digits.length === 10 && /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
  }
  function validEmail(email) {
    return EMAIL_RE.test(String(email || '').trim());
  }

  function markSelected(name) {
    form.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
      var wrap = input.closest('.rr-choice');
      if (wrap) wrap.classList.toggle('is-selected', input.checked);
    });
  }

  function toggleFromReason() {
    var reason = checked('return_reason');
    var contact = $('contact-section');
    var details = $('return-details-section');
    var photos = $('photo-section');
    var customer = CUSTOMER_FAULT.indexOf(reason) !== -1;
    var company = COMPANY_FAULT.indexOf(reason) !== -1;

    show(contact, !!(customer || company));
    show(details, !customer && !!reason);
    show(photos, company);
    if (contact) contact.classList.toggle('is-company-fault', company);

    if (customer) {
      var desc = $('user_description');
      if (desc) desc.value = '';
    }
    if (!company) {
      for (var i = 1; i <= 4; i++) clearSlot(i);
    }
    if (!customer && !company) {
      show($('part-numbers-section'), false);
    }
  }

  function toggleEntireOrder() {
    var entire = checked('entire_order');
    var wrap = $('part-numbers-section');
    var field = $('part_numbers_returning');
    var showParts = entire === 'no';
    show(wrap, showParts);
    if (!showParts && field) field.value = '';
  }

  function imageCount() {
    var n = 0;
    for (var i = 1; i <= 4; i++) {
      var input = $('file' + i);
      if (input && input.files && input.files.length) n += 1;
    }
    return n;
  }

  function updateIncomingMessage() {
    var orderId = val('order_id');
    var entire = checked('entire_order');
    var parts = val('part_numbers_returning');
    var reason = checked('return_reason');
    var details = val('user_description');
    var lines = ['RETURN REQUEST DETAILS', '======================', ''];

    if (orderId) lines.push('Order ID: ' + orderId);
    if (entire) lines.push('Returning Entire Order: ' + (entire === 'yes' ? 'Yes' : 'No'));
    if (parts) lines.push('Part Numbers Returning: ' + parts);
    if (reason) lines.push('Reason for Return: ' + (REASON_LABELS[reason] || reason));

    if (!details && reason) {
      var auto = {
        ordered_wrong_part: 'Customer ordered the wrong part',
        bought_by_mistake: 'Customer bought by mistake',
        ordered_too_many: 'Customer ordered too many items',
        sent_wrong_item: 'Customer was sent the wrong item',
        missing_parts: 'Missing parts in order',
        item_damaged: 'Item arrived damaged',
        does_not_fit: 'Item does not fit as expected',
        not_like_picture: 'Item does not match the picture',
        other: 'Other reason for return'
      };
      details = auto[reason] || 'Return requested';
    }
    if (details) {
      lines.push('');
      lines.push('RETURN DETAILS:');
      lines.push(details);
    }

    var photos = imageCount();
    if (photos) {
      lines.push('');
      lines.push('Photos Uploaded: ' + photos);
    }
    lines.push('');
    lines.push('Submitted from: patiodoorparts.com/pages/return-request');

    var message = $('incomingmessage');
    if (message) message.value = lines.join('\n');

    var title = form.querySelector('input[name="title"]');
    if (title) {
      title.value = COMPANY_FAULT.indexOf(reason) !== -1
        ? 'Patio Door Parts - Return Request - High Priority'
        : 'Patio Door Parts - Return Request';
    }
  }

  function showBanner(type, text) {
    var banner = form.querySelector('[data-rr-banner]');
    if (!banner) return;
    banner.hidden = false;
    banner.className = 'rr-banner rr-banner--' + type;
    banner.textContent = text;
    banner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideBanner() {
    var banner = form.querySelector('[data-rr-banner]');
    if (banner) banner.hidden = true;
  }

  function validate() {
    var reason = checked('return_reason');
    if (!reason) return 'Please select a reason for your return.';

    var contactOn = isVisible($('contact-section'));
    if (contactOn) {
      if (val('firstname').length < 2) return 'Please enter your first name.';
      if (val('lastname').length < 2) return 'Please enter your last name.';
      if (!validEmail(val('email'))) return 'Please enter a valid email address.';
      if (!validPhone(val('phone'))) return 'Please enter a valid US phone number.';
      if (val('order_id').length < 3) return 'Please enter your Order ID.';
      if (!checked('entire_order')) return 'Please tell us if you are returning the entire order.';
      if (checked('entire_order') === 'no' && val('part_numbers_returning').length < 2) {
        return 'Please enter the part numbers you are returning.';
      }
    }

    if (isVisible($('return-details-section')) && val('user_description').length < 10) {
      return 'Please describe your return in more detail (at least 10 characters).';
    }

    if (isVisible($('photo-section'))) {
      var f1 = $('file1');
      var f2 = $('file2');
      if (!(f1 && f1.files && f1.files.length)) return 'Please upload required photo 1.';
      if (!(f2 && f2.files && f2.files.length)) return 'Please upload required photo 2.';
    }
    return null;
  }

  function isPhoto(file) {
    if (!file) return false;
    if (/^image\/(jpeg|jpg|png|gif|webp)$/i.test(file.type)) return true;
    return /\.(jpe?g|png|gif|webp)$/i.test(file.name || '');
  }

  function compressImage(file, done) {
    if (!file.type || file.type.indexOf('image/') !== 0 || typeof createImageBitmap === 'undefined') {
      done(file);
      return;
    }
    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function () {
      var maxW = 1200;
      var maxH = 900;
      var w = img.width;
      var h = img.height;
      if (w > maxW) { h = Math.round((h * maxW) / w); w = maxW; }
      if (h > maxH) { w = Math.round((w * maxH) / h); h = maxH; }
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      canvas.toBlob(function (blob) {
        if (!blob) { done(file); return; }
        done(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), { type: 'image/jpeg' }));
      }, 'image/jpeg', 0.75);
    };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      done(file);
    };
    img.src = url;
  }

  function setPreview(n, file) {
    var area = $('upload-area-' + n);
    var content = $('upload-content-' + n);
    var preview = $('image-preview-' + n);
    var box = $('image-container-' + n);
    var nameEl = $('file-name-' + n);
    if (!area || !content || !preview || !box) return;

    box.innerHTML = '';
    if (!file) {
      content.hidden = false;
      preview.hidden = true;
      if (nameEl) nameEl.textContent = '';
      area.classList.remove('is-filled');
      return;
    }

    var img = document.createElement('img');
    img.alt = 'Preview ' + n;
    img.src = URL.createObjectURL(file);
    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'rr-upload__remove';
    remove.setAttribute('aria-label', 'Remove photo ' + n);
    remove.textContent = '×';
    remove.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearSlot(n);
    });
    box.appendChild(img);
    box.appendChild(remove);
    content.hidden = true;
    preview.hidden = false;
    area.classList.add('is-filled');
    if (nameEl) nameEl.textContent = file.name;
  }

  function clearSlot(n) {
    var input = $('file' + n);
    if (input) {
      input.value = '';
      input.dataset.processing = '';
    }
    setPreview(n, null);
    updateIncomingMessage();
  }

  function handleFile(input, n) {
    var file = input.files && input.files[0];
    if (!file) { setPreview(n, null); return; }
    if (!isPhoto(file)) {
      showBanner('error', 'Please choose a JPG or PNG photo.');
      input.value = '';
      return;
    }
    if (file.size > MAX_PHOTO_BYTES) {
      showBanner('error', 'Each photo must be 10 MB or smaller.');
      input.value = '';
      return;
    }
    compressImage(file, function (ready) {
      if (ready !== file && typeof DataTransfer !== 'undefined') {
        var dt = new DataTransfer();
        dt.items.add(ready);
        input.files = dt.files;
      }
      setPreview(n, ready);
      hideBanner();
      updateIncomingMessage();
    });
  }

  function initUploads() {
    for (var i = 1; i <= 4; i++) {
      (function (n) {
        var input = $('file' + n);
        var area = $('upload-area-' + n);
        if (!input || !area) return;
        input.addEventListener('change', function () { handleFile(input, n); });
        area.addEventListener('click', function (e) {
          if (e.target.closest('.rr-upload__remove')) return;
          if (!area.classList.contains('is-filled')) input.click();
        });
        ['dragenter', 'dragover'].forEach(function (evt) {
          area.addEventListener(evt, function (ev) {
            ev.preventDefault();
            area.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function (evt) {
          area.addEventListener(evt, function (ev) {
            ev.preventDefault();
            area.classList.remove('is-dragover');
          });
        });
        area.addEventListener('drop', function (ev) {
          ev.preventDefault();
          var files = ev.dataTransfer && ev.dataTransfer.files;
          if (!files || !files.length) return;
          if (typeof DataTransfer !== 'undefined') {
            var dt = new DataTransfer();
            dt.items.add(files[0]);
            input.files = dt.files;
          }
          handleFile(input, n);
        });
      })(i);
    }
  }

  function goHome() {
    window.location.assign(form.getAttribute('data-home-url') || '/');
  }

  function stayForAnother(dialog) {
    if (dialog && dialog.open) dialog.close();
    hideBanner();
    var top = $('return-request') || form;
    if (top && top.scrollIntoView) {
      top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    var firstReason = form.querySelector('input[name="return_reason"]');
    if (firstReason) firstReason.focus();
  }

  function showSuccess() {
    var dialog = $('return-success');
    if (!dialog || typeof dialog.showModal !== 'function') {
      showBanner('success', 'Return request submitted. If approved, we will email an RA number.');
      return;
    }
    if (!dialog.dataset.bound) {
      dialog.dataset.bound = '1';
      var again = dialog.querySelector('[data-rr-success-again]');
      var home = dialog.querySelector('[data-rr-success-home]');
      if (again) again.addEventListener('click', function () { stayForAnother(dialog); });
      if (home) home.addEventListener('click', goHome);
      dialog.addEventListener('cancel', function (ev) {
        ev.preventDefault();
        stayForAnother(dialog);
      });
      dialog.addEventListener('click', function (ev) {
        if (ev.target === dialog) stayForAnother(dialog);
      });
    }
    dialog.showModal();
  }

  function setSubmitting(on) {
    var btn = $('submitter');
    if (!btn) return;
    btn.disabled = on;
    btn.classList.toggle('is-loading', on);
    if (on) {
      btn.dataset.orig = btn.textContent;
      btn.textContent = 'Submitting return request…';
    } else if (btn.dataset.orig) {
      btn.textContent = btn.dataset.orig;
    }
  }

  function submissionFrame() {
    var name = form.getAttribute('target') || 'ns_case_return';
    var iframe = document.querySelector('iframe[name="' + name + '"]');
    if (!iframe) return null;
    if (form.contains(iframe)) form.insertAdjacentElement('afterend', iframe);
    return iframe;
  }

  function submitIframe(onDone) {
    var iframe = submissionFrame();
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      onDone();
    }
    function post() {
      if (iframe) iframe.addEventListener('load', finish, { once: true });
      HTMLFormElement.prototype.submit.call(form);
      setTimeout(finish, 2500);
    }
    // NetSuite's external form redirects to allaboutdoors.com after submit.
    // allow-forms lets the POST land in this frame. Scripts and top navigation
    // stay off so that redirect cannot replace this page.
    if (iframe && iframe.getAttribute('sandbox') !== 'allow-forms') {
      iframe.addEventListener('load', post, { once: true });
      iframe.setAttribute('sandbox', 'allow-forms');
      return;
    }
    post();
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.name === 'return_reason') {
      markSelected('return_reason');
      toggleFromReason();
    }
    if (t.name === 'entire_order') {
      markSelected('entire_order');
      toggleEntireOrder();
    }
    updateIncomingMessage();
  });
  form.addEventListener('input', updateIncomingMessage);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideBanner();
    var hp = form.querySelector('[name="pi_hp_url"]');
    if (hp && hp.value) return;
    if (Date.now() - loadTime < MIN_SUBMIT_MS) {
      showBanner('error', 'Please review your request before submitting.');
      return;
    }
    var err = validate();
    if (err) {
      showBanner('error', err);
      return;
    }
    updateIncomingMessage();
    setSubmitting(true);
    submitIframe(function () {
      setSubmitting(false);
      form.reset();
      for (var i = 1; i <= 4; i++) setPreview(i, null);
      show($('contact-section'), false);
      show($('return-details-section'), false);
      show($('photo-section'), false);
      show($('part-numbers-section'), false);
      var contactReset = $('contact-section');
      if (contactReset) contactReset.classList.remove('is-company-fault');
      form.querySelectorAll('.rr-choice').forEach(function (el) { el.classList.remove('is-selected'); });
      showSuccess();
    });
  });

  initUploads();
  show($('contact-section'), false);
  show($('return-details-section'), false);
  show($('photo-section'), false);
  show($('part-numbers-section'), false);
})();
